var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0538 6.4375C26.9334 6.4375 27.3733 6.4375 27.7361 6.52544C28.8734 6.80109 29.7614 7.68906 30.037 8.82636C30.125 9.18917 30.125 9.629 30.125 10.5087V20.5C30.125 23.4462 30.125 24.9194 29.2097 25.8347C28.2944 26.75 26.8213 26.75 23.875 26.75H22.3125H9.8125H8.25C5.30372 26.75 3.83058 26.75 2.9153 25.8347C2 24.9194 2 23.4462 2 20.5V10.5087C2 9.629 2 9.18917 2.08794 8.82636C2.36361 7.68906 3.25158 6.80109 4.38886 6.52544C4.75167 6.4375 5.19152 6.4375 6.07117 6.4375C6.56403 6.4375 6.81045 6.4375 7.04078 6.40297C7.75367 6.29613 8.40769 5.94609 8.89203 5.41222C9.04852 5.23972 9.1852 5.03469 9.45859 4.62461L9.8125 4.09375C10.4318 3.16475 10.7415 2.70025 11.1648 2.38073C11.4233 2.18561 11.7106 2.03186 12.0164 1.925C12.5171 1.75 13.0753 1.75 14.1919 1.75H17.9331C19.0497 1.75 19.608 1.75 20.1086 1.925C20.4144 2.03186 20.7017 2.18561 20.9602 2.38073C21.3834 2.70025 21.6931 3.16475 22.3125 4.09375L22.6664 4.62461C22.9398 5.03469 23.0764 5.23972 23.233 5.41222C23.7173 5.94609 24.3714 6.29613 25.0842 6.40297C25.3145 6.4375 25.5609 6.4375 26.0538 6.4375Z",
    stroke: "#6B80B0",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7499 15.8125C20.7499 18.4014 18.6513 20.5 16.0624 20.5C13.4735 20.5 11.3749 18.4014 11.3749 15.8125C11.3749 13.2236 13.4735 11.125 16.0624 11.125C18.6513 11.125 20.7499 13.2236 20.7499 15.8125Z",
    stroke: "#6B80B0",
    strokeWidth: 2.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9888,
    cy: 15.7389,
    r: 4.21346,
    fill: "#6B80B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.2685ad96daa4cc33bb33906e0d8dba72.svg";
export { ForwardRef as ReactComponent };